module.exports = __webpack_public_path__ + "static/img/30008 (3).cdd3d4b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30008 (3).webp
// module id = Po6w
// module chunks = 14